var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", { staticClass: "mt-3", attrs: { page: _vm.page } }),
      _c("FilterManager", {
        ref: "filterComponent",
        staticClass: "mb-4 c-filterManager",
        attrs: { filters: _vm.filtersConfig },
        on: {
          search: function($event) {
            return _vm.search(1)
          }
        },
        model: {
          value: _vm.filtersSelected,
          callback: function($$v) {
            _vm.filtersSelected = $$v
          },
          expression: "filtersSelected"
        }
      }),
      _vm.pagination.totalItemCount > 0
        ? _c("separator", {
            staticClass: "my-3",
            attrs: { text: "Resultados de Espacios Disponibles" }
          })
        : _vm._e(),
      _vm._l(_vm.pagination.data, function(result, index) {
        return _c("row", {
          key: result.clientAppointmentSpaceID,
          ref: "rowRef",
          refInFor: true,
          staticClass: "mb-3",
          attrs: { index: index, value: result },
          on: {
            "close-all-details": _vm.closeAllDetails,
            "create-space": _vm.onCreateSpaceHandler,
            "delete-space": _vm.onDeleteSpaceHandler,
            "edit-space": _vm.onEditSpaceHandler
          }
        })
      }),
      _vm.pagination.totalItemCount === 0
        ? _c("not-available-space", {
            staticClass: "mt-2",
            attrs: { message: "No existen espacios disponibles." }
          })
        : _vm._e(),
      _vm.pagination.totalItemCount > 15
        ? _c("pagination", {
            attrs: { data: _vm.pagination },
            on: { "pagination-go-page": _vm.setCurrentPage }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }